import React, { FunctionComponent } from "react";

import { classNames } from "../constants";

export type SectionPanelHeaderProps = {
    /** Pří uvedení popisku se vyrenderuje h4 s vloženým textem */
    title?: string;
    /** ID pro DOM, vhodné například pro přístupnost. */
    id?: string;
};

export const SectionPanelHeader: FunctionComponent<SectionPanelHeaderProps> = ({ title, id, children }) => {
    return (
        <section className={classNames("header")} id={id}>
            { title && <h4>{ title }</h4>}
            { children }
        </section>
    );
};
